export const SESSION_IDLE_MS = 30 * 24 * 60 * 60 * 1000;
export const SESSION_ABSOLUTE_MS = 90 * 24 * 60 * 60 * 1000;
export const SESSION_RENEW_AFTER_MS = 24 * 60 * 60 * 1000;

export function sessionCookieName(production: boolean) {
  return production ? '__Host-riz_session' : 'riz_session';
}

// Outlives the session so an expired or cleared session can still resolve back
// to the same guest row. Held separately from the session cookie because it
// identifies the browser, not the login.
export const BROWSER_ID_MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;

export function browserIdCookieName(production: boolean) {
  return production ? '__Host-riz_bid' : 'riz_bid';
}

export function sessionDeadlines(now = new Date()) {
  return {
    expiresAt: new Date(now.getTime() + SESSION_IDLE_MS),
    absoluteExpiresAt: new Date(now.getTime() + SESSION_ABSOLUTE_MS),
  };
}

export function renewedSessionExpiry(absoluteExpiresAt: Date, now = new Date()) {
  return new Date(Math.min(now.getTime() + SESSION_IDLE_MS, absoluteExpiresAt.getTime()));
}

export function isSessionActive(
  session: { expiresAt: Date; absoluteExpiresAt: Date; revokedAt: Date | null },
  now = new Date(),
) {
  return !session.revokedAt && session.expiresAt > now && session.absoluteExpiresAt > now;
}

export function shouldRenewSession(lastSeenAt: Date, now = new Date()) {
  return now.getTime() - lastSeenAt.getTime() >= SESSION_RENEW_AFTER_MS;
}
